import { defineStore } from 'pinia';

const getStoredConfig = () => {
	try {
		const stored = uni.getStorageSync('config-store')
		return stored ? JSON.parse(stored) : null
	} catch (e) {
		return null
	}
}

const storedConfig = getStoredConfig()

const config = defineStore({
	id: 'config',
	state: () => ({
		wish: storedConfig?.wish || {} as any,
		app: storedConfig?.app || {} as any,
	}),
	getters: {
		wishConfig: (state) => state.wish || {},
		appConfig: (state) => state.app || {},
	},
	actions: {
		setWishConfig(data : any) {
			this.wish = data;
		},
		setAppConfig(data : any) {
			this.app = data;
		}
	},
	persist: {
		enabled: true,
		strategies: [
			{
				key: 'config-store',
			},
		],
	},
});

export default config;